"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessengerClientState = void 0;
var MessengerClientState;
(function (MessengerClientState) {
    MessengerClientState["OPEN_UNAUTHENTICATED"] = "OPEN_UNAUTHENTICATED";
    MessengerClientState["OPEN_READY"] = "OPEN_READY";
    MessengerClientState["CLOSED"] = "CLOSED";
})(MessengerClientState = exports.MessengerClientState || (exports.MessengerClientState = {}));
//# sourceMappingURL=MessengerClientTypes.js.map